import * as React from "react";
import Paper from "@mui/material/Paper";
import Indexdasbord from "../../../composant/navbar/indexDashbord";
import {
  Box,
  Button,
  Grid,
  Select,
  TextField,
  Typography,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import Datepicker from "react-tailwindcss-datepicker";
import { GetCommand } from "../../../store/slice/CommandDahbordSlice";
import { TableCommands } from "../../../composant/Tables/TableCommands";
import { useState } from "react";

export default function PageCommandDashbord() {
  return (
    <>
      <Indexdasbord
        Children={
          <Box sx={{ overflow: "hidden" }}>
            <CommandDashbord />
          </Box>
        }
      />
    </>
  );
}

export function CommandDashbord({ filterDisplay = true }) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const { commands } = useSelector((state) => state.commands);

  const [nomFilter, setnomFilter] = React.useState("");
  const [telephoneFilter, setTelephoneFilter] = React.useState("");
  const [codeFilter, setCodeFilter] = useState("");
  const dispatch = useDispatch();
  const [DateRange, setDateRange] = useState({
    startDate: null,
    endDate: null,
  });
  const { status } = useSelector((state) => state.commands);
  const [statusSelect, setStatusSelect] = useState(null);
  const [StatusPaiment, SetStatusPaiment] = useState(null);

  const formatDateForAPI = (date) => {
    return date ? new Date(date).toISOString().split("T")[0] : "";
  };

  function reset() {
    setDateRange({ startDate: null, endDate: null });
    setCodeFilter("");
    setTelephoneFilter("");
    setnomFilter("");
  }
  const [debouncedNom, setDebouncedNom] = useState(nomFilter);
  const [debouncedTel, setDebouncedTel] = useState(telephoneFilter);
  const [debouncedCode, setDebouncedCode] = useState(codeFilter);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedNom(nomFilter);
      setPage(0);
    }, 1000);
    return () => clearTimeout(handler);
  }, [nomFilter]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedTel(telephoneFilter);
      setPage(0);
    }, 1000);
    return () => clearTimeout(handler);
  }, [telephoneFilter]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedCode(codeFilter);
      setPage(0);
    }, 1000);
    return () => clearTimeout(handler);
  }, [codeFilter]);

  const getCommadParData = useCallback(() => {
    const data = {
      page,
      rowsPerPage,
      nomFilter: debouncedNom.trim() || "",
      telephoneFilter: debouncedTel.trim() || "",
      codeFilter: debouncedCode.trim() || "",
      statusId: statusSelect || null,
      StatusPaiment:
        StatusPaiment === 0 || StatusPaiment === 1 ? StatusPaiment : null,
      DateRange: {
        startDate: formatDateForAPI(DateRange.startDate) || null,
        endDate: formatDateForAPI(DateRange.endDate) || null,
      },
    };

    dispatch(GetCommand(data));
  }, [
    dispatch,
    page,
    rowsPerPage,
    debouncedNom,
    debouncedTel,
    debouncedCode,
    DateRange,
    statusSelect,
    StatusPaiment,
  ]);

  useEffect(() => {
    getCommadParData();
  }, [page, rowsPerPage, getCommadParData]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Grid container sx={{ padding: "2%" }} spacing={2}>
      <Grid item xs={6}>
        <Typography variant="h4">Orders</Typography>
      </Grid>
      <Grid item xs={6}>
        <Datepicker
          inputClassName="w-full h-14 rounded-md focus:ring-0 font-normal bg-white border border-gray-300 placeholder:text-black-100 text-black dark:bg-black-900 dark:placeholder:text-black-100"
          primaryColor={"blue"}
          value={DateRange}
          onChange={(newDateRange) => {
            setDateRange(newDateRange);
            setPage(0);
          }}
          showShortcuts={true}
          showFooter={true}
          popoverDirection="down"
        />
      </Grid>
      <Grid item xs={12}>
        <Paper sx={{ padding: "2%", minHeight: "600px" }}>
          <Grid container spacing={2}>
            <Grid item xs={2} padding="2%">
              <TextField
                label="Nom"
                type="text"
                variant="outlined"
                sx={{ background: "#F8F8F8" }}
                value={nomFilter}
                fullWidth
                onChange={(e) => setnomFilter(e.target.value)}
              />
            </Grid>

            <Grid item xs={2} padding="2%">
              <TextField
                label="Telephone"
                type="tel"
                variant="outlined"
                sx={{ background: "#F8F8F8" }}
                value={telephoneFilter}
                onChange={(e) => setTelephoneFilter(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={2} padding="2%">
              <TextField
                label="code"
                type="number"
                variant="outlined"
                sx={{ background: "#F8F8F8" }}
                value={codeFilter}
                onChange={(e) => setCodeFilter(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={2} padding="2%">
              <FormControl fullWidth sx={{ background: "#F8F8F8" }}>
                <InputLabel id="status-label">Statut</InputLabel>
                <Select
                  labelId="status-label"
                  id="status"
                  value={statusSelect}
                  label="Statut"
                  onChange={(e) => {
                    setStatusSelect(e.target.value);
                    setPage(0);
                  }}
                >
                  <MenuItem value={null}>All</MenuItem>
                  {status.map((s) => (
                    <MenuItem value={s.id}>{s.NameStatus}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={2} padding="2%">
              <FormControl fullWidth sx={{ background: "#F8F8F8" }}>
                <InputLabel id="status-label">Paiment status</InputLabel>
                <Select
                  labelId="status-label"
                  id="status"
                  value={StatusPaiment}
                  label="Paiment status"
                  onChange={(e) => {
                    SetStatusPaiment(e.target.value);
                    setPage(0);
                  }}
                >
                  <MenuItem value={null}>All</MenuItem>
                  <MenuItem value={1}>Payé</MenuItem>
                  <MenuItem value={0}>Non payé</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={2} padding="2%">
              <Button variant="contained" onClick={reset}>
                Réinitialiser
              </Button>
            </Grid>

            <Grid item xs={12}>
              <TableCommands
                commands={commands}
                refreshCommands={getCommadParData}
                rowsPerPage={rowsPerPage}
                page={page}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
              />
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
}
